import React from 'react'
import { Button, Modal } from 'react-bootstrap';

const ModalPruebaSM = ({ toggleFunction, modalState }) => {
  const formLink = 'https://forms.gle/BTcU2osUA5VPN9Lz6'

  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title>Metodología de la Investigación</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container cupos-container cards-center text-center'>
          {/* <img src={img_modal} alt='Apertura del Concurso de Posgrado de Medicina 2024' className='modal-banner sm card' /> */}

          <p hidden className='heading-title fw-semibold mb-4'></p>

          <div className='info-group mt-1 mb-4'>
            <p className='heading-title-md fw-semibold spaced-sm'>Inscripciones</p>
            <p className='spaced-xs'>Desde 09 de febrero de 2026</p>
            <p className='spaced-xs'>Hasta 13 de febrero de 2026</p>
          </div>

          <div className='info-group mb-3'>
            <p className='heading-title-md fw-bold mb-2'>Inicio del Curso</p>
            <p className='fw-semibold'>02 de marzo de 2026</p>
          </div>

          <a className='btn btn-primary link-button mb-4' href={formLink} target='blank'>
            Formulario de Inscripción
          </a>

          <div className='info-group mt-3 mb-1'>
            <p className='fw-semibold mb-0'>Dr. Freddy Pachano Arenas</p>
            <p className='fw-semibold mb-3'>Director</p>

            <p className='fw-semibold mb-0'>Dra. Vanessa Belloso</p>
            <p className='fw-semibold mb-0'>Secretaria Docente</p>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalPruebaSM }